/**
 * created by li si yi
 * 消息中心
 */
import React, {Component} from 'react';
import {Input, Tabs, Pagination, Modal, message, notification, Button} from "antd";
import PropTypes from "prop-types";
import {Scrollbars} from "react-custom-scrollbars";
import moment from "moment";
import MyIconSvg from "./svg"
import BaseComponent, {bindModuleAuth} from "../../../base/BaseComponent";
import BaseTable from "../../components/baseTable/BaseTable";
import {getInfoFromLocalStorage} from "../../../actions";
import {HEADER_HEIGHT} from "../../../constants";
import UploadWall from "../../../components/upload/UploadWall";
// import MessageToDo from "./component/MessageProcessor";
import {filterXSS, uuid} from "../../../utils";
import iconList from "./component/iconList";

const {TabPane} = Tabs;
const {Search} = Input;
export default class MessageCenter extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            // 选项卡数据
            tabBarList: [
                {
                    key: '0',
                    name: '全部',
                },
                {
                    key: '1',
                    name: '未读',
                },
                {
                    key: '2',
                    name: '已读',
                }
            ],
            titleTabBar: [
                {
                    key: 1,
                    name: '消息中心',
                    // url: '/cm-sites-sys/new/notice/getList',
                },
                {
                    key: 2,
                    name: '通知公告',
                    // url: '',
                },
            ],
            columns: [
                {
                    title: '类型',
                    dataIndex: 'businessCode',
                    key: 'businessCode',
                    width: '150px',
                    ellipsis: true,
                    render: (text, record) => {
                        const {typeList} = this.state;
                        let thisType = typeList.find(item => item.code === record.data.pojoCode);
                        return (
                            <div style={{display: 'flex', padding: 0}}>
                                <MyIconSvg type={iconList(thisType?.code)} style={{size: 24, alignSelf: 'center'}}
                                           colors={["rgb(220, 244, 236)", "rgb(40, 174, 126)"]}/>
                                <div style={{marginLeft: '8px'}}>{thisType && thisType.name ? thisType.name : ""}</div>
                            </div>
                        )
                    }
                },
                {
                    title: '标题',
                    dataIndex: 'title',
                    ellipsis: true,
                    key: 'title',
                    render: (text, record) => {
                        return (
                            <span onClick={() => {
                                this.getRead(record.id);
                                this.updateViewStatus(record.id);
                                // this.state.modalContent = record;
                                this.showModal(record);
                            }} style={{cursor: 'pointer'}} title={record.data.title.replace(/(.{50})/g, "$1\n")}>{record.data.title}</span>
                        )
                    }
                },
                {
                    title: '发布时间',
                    dataIndex: 'createTime',
                    key: 'createTime',
                    ellipsis: true,
                    width: 200,
                    render: (text) => text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : ""
                },
                {
                    title: '来自',
                    dataIndex: 'sender',
                    width: 200,
                    key: 'sender',
                    ellipsis: true,
                    render: (text, record) => {
                        let name = "";
                        if (record.data && record.data.sender) {
                            name = record.data.sender;
                        }
                        if (record.userData && (record.userData.length > 0) && record.userData[0] && record.userData[0].name) {
                            name = record.userData[0].name;
                        }
                        return (
                            <span>{name}</span>
                        )
                    }
                },
                {
                    title: '状态',
                    width: 200,
                    dataIndex: 'status',
                    ellipsis: true,
                    render: (text) => {
                        let background;
                        let status;
                        text == "1" ? background = '#F56C6C' : background = '#87D166';
                        text == "1" ? status = '未读' : status = '已读';
                        return (
                            <div style={{display: 'flex'}}>
                                <div style={{
                                    width: '8px',
                                    height: '8px',
                                    borderRadius: '50%',
                                    background: `${background}`,
                                    alignSelf: 'center',
                                    marginRight: '5px',
                                }}></div>
                                {status}
                            </div>
                        )
                    }
                },
            ],// 消息中心
            columns2: [
                {
                    title: '标题',
                    dataIndex: 'title',
                    ellipsis: true,
                    key: 'title',
                    render: (text, record) => {
                        return (
                            <div style={{
                                height: 24,
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                                cursor: 'pointer'
                            }} onClick={() => {
                                window.loading.show()
                                this.getRead(record.id,()=>{
                                    window.loading.hide()
                                    this.updateViewStatus(record.id);
                                    if(this.state.thisTab === '2'){
                                        this.getStorageFileListByUrls(record.data.object.attachements,()=>{
                                            this.noticeShowModal(record)
                                        })
                                    }else {
                                        this.showModal(record);
                                    }
                                });
                            }}>{record.data.title}</div>
                        )
                    }
                },
                // {
                //     title: '已读',
                //     dataIndex: 'readStatus',
                //     ellipsis: true,
                //     key: 'readStatus',
                //     width: 150,
                //     render: (text, record) => {
                //         let content, allData;
                //         if (record.data && record.readPerson >= 0 && (record.data.receiverList || record.data.recipients)) {
                //             allData = record?.data?.receiverList?.length ? record.data.receiverList.length : record?.data.recipients.length ? record.data.recipients.length : '0';
                //             content = `${record.readPerson}/${allData}`;
                //             if (allData === record.readPerson) {
                //                 content = '全部已读'
                //             }
                //         }
                //         return (
                //             <span>{content}</span>
                //         )
                //     }
                // },
                {
                    title: '发送者',
                    dataIndex: 'sender',
                    width: 150,
                    key: 'sender',
                    ellipsis: true,
                    render: (text, record) => {
                        let name = "";
                        if (record.data && record.data.sender) {
                            name = record.data.sender;
                        }
                        if (record.userData && (record.userData.length > 0) && record.userData[0] && record.userData[0].name) {
                            name = record.userData[0].name;
                        }
                        return (
                            <span>{name}</span>
                        )
                    }
                },
                {
                    title: '发布时间',
                    dataIndex: 'createTime',
                    key: 'createTime',
                    ellipsis: true,
                    width: 200,
                    render: (text) => text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : ""
                },
                {
                    title: '状态',
                    width: 200,
                    dataIndex: 'status',
                    ellipsis: true,
                    render: (text) => {
                        let background;
                        let status;
                        text == "1" ? background = '#F56C6C' : background = '#87D166';
                        text == "1" ? status = '未读' : status = '已读';
                        return (
                            <div style={{display: 'flex'}}>
                                <div style={{
                                    width: '8px',
                                    height: '8px',
                                    borderRadius: '50%',
                                    background: `${background}`,
                                    alignSelf: 'center',
                                    marginRight: '5px',
                                }}></div>
                                {status}
                            </div>
                        )
                    }
                },
            ],// 通知公告
            params: {
                pageNum: 1,
                pageSize: 10,
                status: "",
                searchInfo: "",
                userAccount: "",
                userId: "",
                deptId: "",
            },
            dataSource: [],// 表格数据
            total: 0,// 总数
            typeList: [], // 类型列表
            visible: false, // 弹框
            modalContent: {},// 弹框内容
            thisTab: "1",// 消息中心or通知公告
            readThisTab: "0",// 已读未读Tab
            attachements: [],//附件
            noticeVisible:false,
        };
    }

    componentWillMount() {
        let account = getInfoFromLocalStorage("currentUser").account;
        let id = getInfoFromLocalStorage("currentUser").id;
        let deptId = getInfoFromLocalStorage("currentUser").defaultInfo.dept.id;
        this.state.params.userAccount = account;
        this.state.params.userId = id;
        this.state.params.deptId = deptId;
        this.getBusinessInfo(()=> this.getDataSource());
        // this.getDataSource();
    }

    componentDidMount() {
        this.request({
            url: "/cm-sites-sys/businessModule/getAllBusinessModulesAndBindCode",
            body: {deptId: window.top.currentUser.defaultInfo.dept.id},
            method: 'post',
            callBack: (res) => {
                if (res) {
                    if (res.bindModuleBusiness) {
                        let titleTabBar = [];
                        if (res.bindModuleBusiness.indexOf('default') > -1) {
                            titleTabBar = [
                                {
                                    key: 1,
                                    name: '消息中心',
                                    // url: '/cm-sites-sys/new/notice/getList',
                                },
                                {
                                    key: 2,
                                    name: '通知公告',
                                    // url: '',
                                },
                            ]
                        } else {
                            titleTabBar = [
                                {
                                    key: 1,
                                    name: '消息中心',
                                    // url: '/cm-sites-sys/new/notice/getList',
                                }

                            ]
                        }
                        this.setState({titleTabBar: titleTabBar})
                    }

                }

            },
        });



        // status  true  可以展示     serverHost  cm-sits-pms 等，接口前缀
    }

    // 获取选项卡内容数据
    getDataSource = (call) => {
        // let {params} = this.state;
        let params = {};
        if (this.state.thisTab === "2") {
            params = {
                ...this.state.params,
                "pojoCode": "default",
                "ifShield":true
            }
        } else {
            params = this.state.params;
        }
        this.request({
            url: "/cm-sites-sys/new/notice/getList",
            body: params,
            method: 'post',
            contentType: 'json',
            loading: false,
            callBack: (res) => {
                let total = 0;
                let dataSource = [];
                if (res) {
                    dataSource = res.list;
                    total = res.count;
                    this.setState({total, dataSource});
                } else {
                    message.error("数据获取失败！");
                }
                call && call(dataSource)
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    };
    // 读取消息
    getRead = (id,call) => {


    this.request({
        url: `/cm-sites-sys/new/notice/read/${id}`,
        loading: false,
        callBack: (res) => {
            if (res) {
                this.getDataSource(call)
            } else {
                message.error("读取消息失败！");
            }
        },
        errorCallBack: (e) => {
            console.log(e)
        }
    });

    };
    //更新查看状态
    updateViewStatus(noticeId){
        if(noticeId){
            this.request({
                url:'/cm-sites-sys/notice/updateNoticeStatisticsStatus',
                method:'post',
                body:{noticeId},
                callBack:(res)=>{
                    console.log(res)
                }
            })
        }

    }
    // 类型
    getBusinessInfo = (call) => {
        this.request({
            url: "/cm-sites-sys/noticeTemplateController/getPojoInfo",
            method: 'post',
            contentType: 'json',
            callBack: (res) => {

                let typeList = [];
                if (res) {
                    typeList = res.data
                } else {
                    message.error("类型获取失败！");
                }
                this.setState({typeList})
                call&&call();
            },
            errorCallBack: (e) => {
                console.log(e)
                call&&call();
            }
        });
    };

    render() {
        return (
            <div className="card-container"
                 style={{
                     marginTop: '15px',
                     marginLeft: '15px',
                     borderRadius: '5px',
                     height: 'calc(100vh - 100px)'
                 }}>
                {this.renderTitleTabBar()}
                <div style={{background: '#fff', borderRadius: '0 0 5px 5px'}}>
                    {/*选项卡*/}
                    {this.renderTabBar()}
                    {/*搜索*/}
                    {this.renderSearch()}
                    {/*内容*/}
                    {this.renderTable()}
                    {/*消息中心弹框*/}
                    {this.renderModal()}
                    {/*通知公告弹窗*/}
                    {this.renderNoticeModal()}
                </div>
                {/*<MessageToDo ref={ref => this.MessageToDo = ref}/>*/}
            </div>
        )
    }

    // 选项卡
    renderTabBar = () => {
        return (
            <div className={'tabBarStyle'}>
                <Tabs activeKey={this.state.readThisTab} onChange={this.changeTabBar}>
                    {
                        this.state.tabBarList.map((item) => {
                            return (
                                <TabPane tab={item.name} key={item.key}
                                         style={{
                                             backgroundColor: '#fff',
                                             color: '#0050B3',
                                         }}/>
                            )
                        })
                    }
                </Tabs>
                <style>
                    {`
                        .tabBarStyle .ant-tabs-nav{
                             padding-left: 16px;
                             padding-top:5px;
                         }
                    `}
                </style>
            </div>
        )
    };
    // 头部选项卡
    renderTitleTabBar = () => {
        return (
            <Tabs type="card" activeKey={this.state.thisTab} onChange={this.changeTitleTabBar}
                  style={{color: 'rgba(0, 0, 0, 0.65)', fontSize: '16px'}}>
                {
                    this.state.titleTabBar.map((item, index) => {
                        return (
                            <TabPane tab={item.name} key={item.key} style={{backgroundColor: '#fff'}}/>
                        )
                    })
                }
            </Tabs>
        )
    };
    // 搜索
    renderSearch = () => {
        return (
            <Search
                ref='searchBar'
                allowClear
                placeholder="请输入消息标题"
                onSearch={(value) => {
                    this.searchChange(value)
                }}
                style={{width: 224, height: '32', margin: '24px 32px'}}
            />
        )
    };
    // 内容部分
    renderTable = () => {
        let height = window.innerHeight - HEADER_HEIGHT - 280;
        return (
            <div key={this.state.thisTab} className={'messageCenter'}>
                <div style={{padding: '0 32px', maxHeight: this.state.dataSource.length ? height : height + 81}}>
                    <Scrollbars autoHeight autoHeightMax={height}>
                        <BaseTable rowKey={'_id'} dataSource={this.state.dataSource}
                                   columns={this.state.thisTab === "1" ? this.state.columns : this.state.columns2}
                                   pagination={false}/>
                    </Scrollbars>
                </div>
                {/*分页*/}
                {this.state.dataSource.length ? this.renderFooter() : null}
                <style>{`
                    .messageCenter .ant-table-placeholder{
                       display:flex;
                       justify-content: center;
                       align-items: center;
                       height:500px;
                       border-bottom:none;
                    }
                `}</style>
            </div>
        )
    };
    // 分页
    renderFooter = () => {
        let {params, total} = this.state;
        let {pageNum, pageSize} = params;
        return (
            <div className={'pagination'}>
                <div style={{marginRight: '5px'}}>共 {total} 条</div>
                <Pagination
                    showSizeChanger
                    current={pageNum}
                    pageSize={pageSize}
                    total={total}
                    showQuickJumper={true}
                    onChange={this.pageChange}
                    onShowSizeChange={this.pageChange}
                />
            </div>
        )
    };

    noticeShowModal = (record) => {
        this.setState({
            noticeVisible: true,
            noticedData:record
        });
    };
    handleOk = () => {
        this.handleCancel()
    };

    handleCancel = () => {
        this.state.attachements = []
        this.setState({
            noticeVisible: false,
        });
    };

    //通知公告弹窗
    titleHeight=0
    renderNoticeModal (){
        let {noticedData,attachements} =this.state
        return (
            <div className={'modalHeader'}>
                <Modal
                    key={uuid()}
                    title ={'通知公告详情'}
                    visible={this.state.noticeVisible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    width={1200}
                    footer={null}
                    bodyStyle={{padding: 0}}
                    className={"modalHeader"}
                >
                    <div style={{height:700}}>
                        {noticedData?.data?.object?.content ?
                            <div
                                style={{padding: '20px 40px'}}
                                ref={ref => {
                                    if (typeof ref?.offsetHeight === "number" && ref.offsetHeight !== this.titleHeight) {
                                        this.titleHeight = ref.offsetHeight;
                                        this.setState({})
                                    }
                                }}
                            >
                                <div style={{fontSize:20,fontWeight:'bold'}}>{noticedData?.data?.object?.title}</div>
                                <div style={{borderBottom:'1px solid #cccccc',padding:'16px 0px',fontSize:14}}>
                                    <span
                                        style={{marginRight: 30}}>发布人：{noticedData?.userData?.[0]?.name || noticedData?.data?.sender}</span>
                                    <span style={{marginRight:30}}>发布范围：
                                            {(()=>{
                                            let text = "";
                                            switch (noticedData?.data?.object?.receiveRange) {
                                                case "all":
                                                    text = "全部";
                                                    break;
                                                case "users":
                                                    text = "指定个人";
                                                    break;
                                                case "depts":
                                                    text = "指定部门";
                                                    break;
                                            }
                                            return text
                                        })()}
                                </span>
                                    <span style={{marginRight:30}}>发布时间：{moment(noticedData?.data?.createTime).format('YYYY-MM-DD HH:mm:ss')}</span>
                                    {/*<span>作者：{noticedData?.data?.sender}</span>*/}
                                </div>
                            </div>
                            :<div style={{padding: '20px 40px',fontWeight:'bold'}} >{noticedData?.data?.content}</div>
                            }

                        <Scrollbars style={{height: 700 - 1 - 32 - this.titleHeight - (attachements.length ? 200 : 0)}}>
                            <div style={{padding: "0px 30px"}}> {/*w-e-text 编辑器表格*/}
                                <div className={"w-e-text"} dangerouslySetInnerHTML={{__html: filterXSS(noticedData?.data?.object?.content || "")}}></div>
                            </div>
                        </Scrollbars>
                        {attachements && attachements.length>0?<>
                            <div style={{width:'100%',height:1,backgroundColor:'#cccccc',margin:'16px 0px'}}></div>
                            <Scrollbars style={{height:200}}>
                                <div style={{padding:'0px 40px'}}>
                                    <div style={{marginTop: "20px",fontWeight:700}}>附件
                                        <UploadWall
                                            accept={"*"}
                                            multiple={true}
                                            action="/storage/uploadFile"
                                            listType={'list'}
                                            fileList={this.state.storageFileList}
                                            icons={["download"]}
                                            showUploadBtn={false}
                                            onChange={() => {
                                            }}
                                            onRemove={() => {
                                            }}
                                            onDownload={(file) => {
                                                if (file.path.indexOf("?") === -1) {
                                                    window.location.href = file.path + "?download=1";
                                                } else {
                                                    window.location.href = file.path + "&download=1";
                                                }
                                            }}
                                        />
                                    </div>

                                </div>
                            </Scrollbars>
                        </>:''}
                    </div>

                </Modal>
            </div>
            )

    };
    // 弹框

    renderModal = () => {
        let {modalContent, visible} = this.state;
        let content = modalContent?.data?.content || modalContent?.data?.object.content;
        // let title = modalContent.data && modalContent.data.object && modalContent.data.object.title || modalContent.data && modalContent.data.title;
        let title = modalContent?.data?.title || modalContent?.data?.object?.title;

        return (
            <div className={'modalStyle'}>
                <Modal
                    title="消息提醒"
                    visible={visible}
                    className={'modalImg'}
                    onOk={this.hideModal}
                    onCancel={this.hideModal}
                    centered={true}
                    style={{maxWidth:'650px',maxHeight:'400px'}}
                    footer={[
                        <Button onClick={this.hideModal} key={'1'}>关闭</Button>,
                        // <Button
                        //     // disabled={modalContent && modalContent.data && modalContent.data.object && modalContent.data.object.content && modalContent.data.object.title ? false : true}
                        //     type="primary"
                        //     onClick={() => {
                        //         this.onLink(modalContent);
                        //     }} key={'2'}>查看</Button>,
                    ]}
                >
                    <Scrollbars autoHide  autoHeight
                                autoHeightMax={400}>
                        <div style={{padding: '10px'}} className={"modalContent"}>
                            <div style={{
                                marginBottom: '10px',
                                fontSize: '14px',
                                fontWeight: 600,
                                color: '#000'
                            }}>{title}</div>
                            {/*<divwojue*/}
                            {/*    dangerouslySetInnerHTML={{__html: filterXSS(content)}}*/}
                            {/*    className={'w-e-text'}*/}
                            {/*/>*/}
                        </div>
                    </Scrollbars>
                </Modal>
                <style>
                    {`
                        .modalImg img{
                             width:100%;
                             height:auto;
                        }
                        .modalContent .w-e-text{
                            padding:0 10px 0 0;
                        }
                           // .modalStyle .ant-modal-footer{
                           //      text-align:right !important;
                           //      border-top:none;
                           //  }
                           // .modalStyle .ant-modal .ant-modal-header{
                           //       border-bottom:none;
                           //       background-color:#fff !important;
                           //  }
                       `}
                </style>
            </div>
        )
    };
    // 查看链接跳转
    onLink = (modalContent) => {
        console.log(modalContent)
        // console.log(modalContent.data.noticeConnection);
        // if (modalContent.data.noticeConnection && modalContent.data.noticeConnection !== "0") {
        //     window.open(modalContent.data.noticeConnection);
        // } else {
        this.itemTodoClick(modalContent);
        // }
    };
    // 分页改变
    pageChange = (pageNum, pageSize) => {
        console.log(pageNum, pageSize);
        let {params} = this.state;
        // 获取当前tab参数
        params.pageNum = pageNum;
        params.pageSize = pageSize;
        this.getDataSource();
    };
    // 选项卡改变
    changeTabBar = (key) => {
        let {params} = this.state;
        // 获取当前tab参数
        if (key === "0") {
            params.status = "";
        } else {
            params.status = key;
        }
        this.state.readThisTab = key;
        this.state.params.searchInfo = "";
        this.state.params.pageNum = 1;
        this.state.params.pageSize = 10;
        this.setState({}, () => {
            this.reset();
            this.getDataSource();
        })
    };
    // 头部选项改变
    changeTitleTabBar = (key) => {
        // 获取当前tab参数
        this.state.params.searchInfo = "";
        this.state.params.pageNum = 1;
        this.state.thisTab = key;
        this.changeTabBar("0");
        this.reset();
        // this.getDataSource();
        this.setState({});
    };
    // 搜索
    searchChange = (value) => {
        let {params} = this.state;
        params.searchInfo = value;
        params.pageNum = 1;
        this.getDataSource();
    };
    // 清空搜索框
    reset = () => {
        this.refs.searchBar.input.state.value = "";
    };
    // 弹框
    showModal = (record) => {
        // this.state.visible = true;
        // if (record
        //     && record.data
        //     && record.data.noticeConnection
        //     && (record.data.object.title || record.data.object.content)) {
        //     this.setState({
        //         modalContent: record,
        //     });
        // }
        this.setState({
            modalContent: record,
            visible: true
        });
    };

    hideModal = () => {
        this.setState({
            visible: false,
        });
    };

    // 点击执行当前方法
    itemTodoClick(item) {
        this.MessageToDo.getTodoList(item);
    }

    //查询附件
    getStorageFileListByUrls(attachements, call) {
        window.loading.show()
        if(!(attachements&&attachements.length)) {
            call&&call(attachements)
            window.loading.hide()
            return false
        }
        let array =[];
        let num = 0;
        let overFun = () => {
            num++;
            if(num===this.state.attachements.length) {
                window.loading.hide()
                call && call(this.state.storageFileList)
            }
        }
        this.state.attachements = attachements
        this.state.attachements && this.state.attachements.length && this.state.attachements.forEach((item, index) => {
            this.request({
                url: '/storage/getStorageFileByUrl',
                body: {
                    url: item
                },
                contentType: "json",
                callBack: (data) => {
                    data.status = 'done';
                    data.ext = data.suffix;
                    data.url = data.path;
                    data.isChunk = true;
                    array.push(data)
                    this.state.storageFileList = array;
                    overFun()
                },
                errorCallBack: (e) => {
                    console.log(e.toString());
                    overFun()
                },
                serverVerify: {
                    serverErrorCallBack: (e) => {
                        console.log(e.toString());
                        overFun()
                    },
                    isShowErrorMsg: true
                },
            });
        })
    }
};

MessageCenter.defaultProps = {};
MessageCenter.propTypes = {};